import Vue from 'vue'
import VueRouter from 'vue-router'

import HomeView from '../views/Home/index.vue'
import GalleryView from '../views/Gallery/index.vue'
import MatchView from '../views/Match/index.vue'
import ProfileView from '../views/Match/profile.vue'
import MineView from '../views/Mine/index.vue'
import InfomationView from '../views/Infomation/index.vue'
import SetNameView from '../views/Infomation/components/setName.vue'
import SetPhoneView from '../views/Infomation/components/setPhone.vue'
import RechargeView from '../views/Recharge/index.vue'
import BankView from '../views/Bank/index.vue'
import BankInfoView from '../views/Bank/info.vue'
import WithdrawalView from '../views/Withdrawal/index.vue'
import PlayVideoView from '../views/Gallery/play.vue'
import VerificationView from '../views/Verification/index.vue'
import LotteryView from '../views/Lottery/index.vue'
import IframeLotteryView from '../views/Lottery/iframe.vue'
import WithdrawRecord from '../views/Withdrawal/record.vue'
import GameRecord from '../views/Lottery/record.vue'
import MattersView from '../views/Matters/index.vue'
import PoninsHistoryView from '../views/PointsHistroy/index.vue'
import MyWatchView from '../views/Mymove/index.vue'
import ChangePwdView from '../views/LoginPwd/index.vue'
import ChangeUsrPwdView from '../views/UsrPwd/index.vue'

import LoginView from '../views/Login/index.vue'
import RegisterView from '../views/Register/index.vue'
import ServiceView from '../views/Service/index.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: GalleryView
  },
  {
    path: '/match',
    name: 'match',
    component: MatchView
  },
  {path:'/Profile',name:'profile',component:ProfileView},
  {
    path: '/mine',
    name: 'mine',
    component: MineView
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: RechargeView
  },
  {
    path: '/infomation',
    name: 'infomation',
    component: InfomationView
  },
  {
    path: '/setname',
    name: 'setname',
    component: SetNameView
  },
  {
    path: '/setphone',
    name: 'setphone',
    component: SetPhoneView
  },
  {
    path: '/bank',
    name: 'bank',
    component: BankView
  },
  {
    path: '/bankinfo',
    name: 'bankinfo',
    component: BankInfoView
  },
  {
    path: '/withdrawal',
    name: 'withdrawal',
    component:WithdrawalView
  },
  {path:'/PlayVideo',name:'PlayVideo',component:PlayVideoView},
  {path: '/verification', name: 'verification',component:VerificationView},
  { path: '/lottery', name: 'lottery',component:LotteryView},
  {path: '/iframelottery', name: 'iframelottery',component:IframeLotteryView},
  { path: '/withddrawrecord', name: 'withddrawrecord',component:WithdrawRecord},
  { path: '/gamerecord', name: 'gamerecord',component:GameRecord },
  { path: '/matter', name: 'matter',component:MattersView},
  { path: '/points', name: 'points',component:PoninsHistoryView},
  { path: '/mymove', name: 'mymove',component:MyWatchView },
  {path: '/changepwd', name: 'changepwd',component:ChangePwdView},
  {path: '/changeusrpwd', name: 'changeusrpwd',component:ChangeUsrPwdView},
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/service',
    name: 'service',
    component: ServiceView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
